function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#231F20",
  d: "M6.395,14.899c-0.383-1.792,0.163-3.429,1.221-3.655 s2.225,1.044,2.608,2.836c0.044,0.206,0.073,0.41,0.093,0.61c0.453-1.092,0.609-2.56,0.267-4.158 C9.283,4.437,8.538-0.501,5.273,0.56c-3.26,1.057-1.523,8.679-1.523,8.679c0.745,3.875,1.895,5.982,3.051,6.854 C6.628,15.734,6.487,15.333,6.395,14.899z"
});

var Svg8 = function Svg8(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000143617183357817037130000002557260287089233058_",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14.02 17",
    enableBackground: "new 0 0 14.02 17",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg8, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/8.104bdf1e.svg";
export { ForwardRef as ReactComponent };